// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.black_and_white[data-v-17588ac4] {\n  -webkit-filter: grayscale(65%);\n          filter: grayscale(65%);\n  opacity: 0.5;\n}", ""]);
// Exports
module.exports = exports;
